/**
 * Online UI API
 * # Summary Elisa B2B Online UI API  # Usage This API is used in the `https://yrityksille.elisa.fi/` pages.  # Identifiers 
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Request to get one time password for pairing subscription with employee
 */
export interface SubscriptionPairingRequest { 
    /**
     * MSISDN of the subscription which employee wants to pair or phone number of the contact which is tagged to the subscription employee wants to pair
     */
    msisdn: string;
    /**
     * Type of subscription employee wants to pair
     */
    subscriptionType: SubscriptionPairingRequest.SubscriptionTypeEnum;
    /**
     * MDM ID of the account where the subscription should be searched
     */
    mdmId?: string;
}
export namespace SubscriptionPairingRequest {
    export type SubscriptionTypeEnum = 'MOBILE' | 'OTHER';
    export const SubscriptionTypeEnum = {
        MOBILE: 'MOBILE' as SubscriptionTypeEnum,
        OTHER: 'OTHER' as SubscriptionTypeEnum
    };
}


